export default __webpack_public_path__ + "static/media/axios-nojob.7e117f42.png";